import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as m } from "../SvgIcon.js";
const c = (r) => /* @__PURE__ */ o(m, { ...r, children: /* @__PURE__ */ o("path", { d: "M10 0c5.5249 0 10 4.47514 10 10 0 5.5249-4.4751 10-10 10-5.52486 0-10-4.4751-10-10C0 4.47514 4.47514 0 10 0Zm5.5138 10L10 4.47514 4.47514 9.98895l.97238.97235 3.8674-3.84528v8.39778h1.38118V7.11602l3.8564 3.85638.9613-.9724Z" }) });
export {
  c as Upload
};
//# sourceMappingURL=Upload.js.map
